import styled from "styled-components"
import { theme } from "../../../../theme"
import {ReactComponent as ArrowIcon} from "images/icons/arrow-left.svg"

export const RowWrapper = styled.div`
  & > div:nth-child(odd) {
    background: #f7f9fc;
  }
  border-bottom: 0.1rem solid ${(p) => p.theme.colors.borderLight};
  border-top: 0.1rem solid ${(p) => p.theme.colors.borderLight};
`

export const TotalWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  font-size: 1.3rem;
  font-weight: 700;
  padding: 1rem 0;
`

export const TotalsInfo = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-size: 1.2rem;
  padding: 0 0.5rem;
`

export const OrderValueWrapper = styled.div`
margin: 2rem 0;
  display: flex;
  justify-content: space-between;
`

export const OrderTotalsContainer = styled.div`
  border: 0.1rem solid ${(p) => p.theme.colors.borderLight};
  border-radius: 0.6rem;
  padding: 2rem;
  background: ${(p) => p.theme.colors.white};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const OrderInfo = styled.div`
  display: grid;
  grid-template-columns: 1fr 4fr 1fr;
  width: 100%;
  font-size: 1.2rem;
  padding: 0 0.5rem;
`

export const OrderDate = styled.div`
  font-size: 1.2rem;
`

export const TotalsList = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.greyLight};
  padding: 1rem 2rem 3rem;
  border-radius: 0.6rem;
  margin-bottom: 2rem;
`

export const Comments = styled(TotalsList)`
  flex-direction: column;
  justify-content: space-between;
  padding: 2rem 3rem 2rem;
  display: flex;
  height: 100%;
  margin-top: 2rem;

  ${theme.mQ.MEDIA_MIN_LARGE} {
    margin-left: 2rem;
    margin-top: 0;
  }
`

export const CommentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const NoComments = styled.div`
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.greyDark};
`

export const AddedComment = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 3rem;

  div {
    line-height: 1.6rem;
  }

  p {
    font-size: 1.1rem;
    margin: 0;
    line-height: 1.2rem;
  }

  b a {
    display: block;
    text-decoration: underline;
    font-size: 1.2rem;
    margin: 0.3rem 0;
    color: ${({ theme }) => theme.colors.greyDarker};

    svg {
      transition: rotate 0.3s ease-in-out;
    }

    &:hover {
      svg {
        rotate: 120deg;
      }
    }
  }
`

export const LinkIcon = styled(ArrowIcon)`
  height: 1.1rem;
  rotate: 140deg;
  margin-left: 0.3rem;
`

export const User = styled.div`
  font-size: 1.1rem;
  font-weight: 700;
  min-width: 2.5rem;
  width: 2.5rem;
  height: 2.5rem;
  background: ${({ theme }) => theme.colors.turquoiseDark};
  border-radius: 0.6rem;
  margin-right: 1rem;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.white};
`

export const Header = styled.div`
  color: ${(p) => p.theme.colors.grey};
  font-weight: 700;
  margin: 2rem 0 0.5rem;
  display: flex;
  justify-content: space-between;

  div {
    color: ${(p) => p.theme.colors.black};
    line-height: 2.4rem;
  }
`

export const TotalOrderValueWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 2rem 0 0;
`

export const TotalOrderValue = styled.div`
  display: flex;
  flex-direction: column;
`

export const TotalOrder = styled.div`
  margin-bottom: 1rem;
`

export const TotalOrderValueTextRight = styled.div`
  text-align: right;
  font-size: 1.2rem;
  line-height: 1.4rem;
`
export const TotalOrderValueTextLeft = styled.div`
  text-align: left;
  font-size: 1.2rem;
  line-height: 1.4rem;
`

export const TotalValueRight = styled.div`
  font-size: 1.8rem;
  font-weight: 700;
  text-align: right;
`

export const TotalValueLeft = styled.div`
  font-size: 1.8rem;
  font-weight: 700;
  text-align: left;
`
